import { UiCaptionModel } from "../../models";

import { mockCaptionModel } from "./mock-caption";

export function mockUiCaptionModel({
    id = "Caption-1234",
    type = "uiCaption",
    locale = "en",
    content = mockUiCaptionModelContent()
}: Partial<UiCaptionModel> = {}): UiCaptionModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiCaptionModelContent = UiCaptionModel["content"];

export function mockUiCaptionModelContent({
    title = "Lorem ipsum",
    caption = mockCaptionModel(),
    appearance = "Overlay 1",
    ...optionals
}: Partial<UiCaptionModelContent> = {}): UiCaptionModelContent {
    return {
        title,
        caption,
        appearance,
        ...optionals
    };
}
